import { render, staticRenderFns } from "./personalCenterLayout.vue?vue&type=template&id=82c08a72&scoped=true&"
import script from "./personalCenterLayout.vue?vue&type=script&lang=js&"
export * from "./personalCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./personalCenterLayout.vue?vue&type=style&index=0&id=82c08a72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c08a72",
  null
  
)

export default component.exports